<template>
	<div class="bottom">
		泉州市文明办、泉州市志工办、共青团泉州市委、泉州市民政局主办，泉州市志愿者协会承办 <br />
		Copyright © 2012-2020 nbzyz.org All Rights Reserved 闵ICP备09012916号-20
	</div>
</template>
<script>
export default {
	name: 'Myfooter'
}
</script>
<style scoped>
.bottom {
	width: 100%;
	height: 11.38vh;
	font-size: 1.296vh;
	line-height: 1.759vh;
	color: #ffffff;
	background: #1e1e1e;
	font-family: MicrosoftYaHei;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
